import { If } from 'cdui-js';
import { For } from 'solid-js';
import { lastProcess, nextProcess, pState } from '../../store';
import { LastNextBtns } from '../../components/LastNextBtns';
import i18n from '../../../../../../i18n';
import { replaceTemplate } from '@china-difi/lib/template';
import { OPEN_ACCOUNT_TRANSFER, formatTransferAmount } from '../../../../utils/open-account-transfer';

export const TransferIntro = () => {
  const T = i18n.OpenProgress.Transfer.Intro;
  const companyName = () => i18n.OpenProgress.Common.DefaultCompanyName;
  const list = [
    {
      title: () => T.Step1Title,
      desc: () => <div></div>,
    },
    {
      title: () => replaceTemplate(T.Step2Title, { name: companyName() }),
      desc: () => (
        <div>
          {T.Step2DescBefore}
          <span class="color-D">{formatTransferAmount(OPEN_ACCOUNT_TRANSFER.minHkd)}</span>
          {T.Step2DescHkd}
          <span class="color-D">{formatTransferAmount(OPEN_ACCOUNT_TRANSFER.minUsd)}</span>
          {T.Step2DescUsd}
        </div>
      ),
    },
    {
      title: () => replaceTemplate(T.Step3Title, { name: companyName() }),
      desc: () => <div></div>,
    },
  ];

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="flex justify-center margin-t-XXL">
        <svg width="92" height="92" viewBox="0 0 92 92" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M46 1C56.411 1 66.4999 4.60987 74.5477 11.2145C82.5955 17.8192 88.1043 27.01 90.1353 37.2209C92.1664 47.4319 90.5942 58.0312 85.6865 67.2128C80.7788 76.3945 72.8393 83.5905 63.2208 87.5746C53.6023 91.5587 42.8999 92.0845 32.9372 89.0623C22.9745 86.0402 14.3679 79.6571 8.58388 71.0007C2.79984 62.3443 0.196235 51.9501 1.21668 41.5893C2.23713 31.2284 6.8185 21.5419 14.1802 14.1802"
            stroke="#02C58D"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M31.7289 38.94C33.4755 38.94 34.8089 39.5667 35.7289 40.82C36.6489 42.06 37.1089 43.7733 37.1089 45.96C37.1089 48.2667 36.6222 50.1533 35.6489 51.62C34.6755 53.06 33.3622 53.78 31.7089 53.78C28.8955 53.78 27.3155 52.48 26.9689 49.88H29.2489C29.5289 51.2 30.3555 51.86 31.7289 51.86C32.6622 51.86 33.4222 51.3933 34.0089 50.46C34.5555 49.5667 34.8289 48.4667 34.8289 47.16V46.98H34.7289C34.3022 47.5667 33.8022 48 33.2289 48.28C32.6555 48.5467 32.0155 48.68 31.3089 48.68C29.8955 48.68 28.7689 48.22 27.9289 47.3C27.1022 46.4333 26.6889 45.2933 26.6889 43.88C26.6889 42.44 27.1689 41.26 28.1289 40.34C29.0755 39.4067 30.2755 38.94 31.7289 38.94ZM31.8089 40.88C30.9689 40.88 30.2889 41.16 29.7689 41.72C29.2622 42.2667 29.0089 42.9867 29.0089 43.88C29.0089 44.7733 29.2622 45.4733 29.7689 45.98C30.2622 46.5133 30.9422 46.78 31.8089 46.78C32.6622 46.78 33.3422 46.5133 33.8489 45.98C34.3422 45.42 34.5889 44.6933 34.5889 43.8C34.5889 42.8933 34.3289 42.18 33.8089 41.66C33.2889 41.14 32.6222 40.88 31.8089 40.88ZM43.0811 38.94C44.7477 38.94 46.0477 39.6333 46.9811 41.02C47.8611 42.34 48.3011 44.12 48.3011 46.36C48.3011 48.6 47.8611 50.38 46.9811 51.7C46.0344 53.0867 44.7344 53.78 43.0811 53.78C41.4011 53.78 40.1011 53.0867 39.1811 51.7C38.3011 50.38 37.8611 48.6 37.8611 46.36C37.8611 44.12 38.3011 42.34 39.1811 41.02C40.0877 39.6333 41.3877 38.94 43.0811 38.94ZM43.0811 40.92C41.9344 40.92 41.1344 41.5533 40.6811 42.82C40.3611 43.6733 40.2011 44.8533 40.2011 46.36C40.2011 47.84 40.3611 49.02 40.6811 49.9C41.1477 51.1667 41.9477 51.8 43.0811 51.8C44.2011 51.8 45.0011 51.1667 45.4811 49.9C45.8011 49.02 45.9611 47.84 45.9611 46.36C45.9611 44.8533 45.8011 43.6733 45.4811 42.82C45.0011 41.5533 44.2011 40.92 43.0811 40.92ZM63.4132 45.68C64.5466 45.68 65.4066 46.0733 65.9932 46.86C66.5266 47.5533 66.7932 48.4667 66.7932 49.6C66.7932 50.7067 66.5266 51.62 65.9932 52.34C65.3799 53.1133 64.5199 53.5 63.4132 53.5C62.2932 53.5 61.4266 53.1133 60.8132 52.34C60.2666 51.6333 59.9932 50.72 59.9932 49.6C59.9932 48.44 60.2666 47.5267 60.8132 46.86C61.3999 46.0733 62.2666 45.68 63.4132 45.68ZM61.3732 38.94H63.1132L55.0932 53.78H53.3532L61.3732 38.94ZM53.0932 39.22C54.2266 39.22 55.0866 39.6133 55.6732 40.4C56.2066 41.0933 56.4732 42.0067 56.4732 43.14C56.4732 44.2467 56.2066 45.16 55.6732 45.88C55.0599 46.6533 54.1999 47.04 53.0932 47.04C51.9732 47.04 51.1066 46.6533 50.4932 45.88C49.9466 45.1733 49.6732 44.26 49.6732 43.14C49.6732 41.98 49.9466 41.0667 50.4932 40.4C51.0799 39.6133 51.9466 39.22 53.0932 39.22ZM63.4132 47.14C62.9066 47.14 62.5532 47.4 62.3532 47.92C62.1932 48.32 62.1132 48.88 62.1132 49.6C62.1132 50.3067 62.1932 50.86 62.3532 51.26C62.5532 51.78 62.9066 52.04 63.4132 52.04C63.8799 52.04 64.2266 51.7667 64.4532 51.22C64.5999 50.8067 64.6732 50.2667 64.6732 49.6C64.6732 48.8933 64.5932 48.34 64.4332 47.94C64.2332 47.4067 63.8932 47.14 63.4132 47.14ZM53.0932 40.68C52.5866 40.68 52.2332 40.94 52.0332 41.46C51.8732 41.86 51.7932 42.42 51.7932 43.14C51.7932 43.8467 51.8732 44.4 52.0332 44.8C52.2332 45.32 52.5866 45.58 53.0932 45.58C53.5599 45.58 53.9066 45.3067 54.1332 44.76C54.2799 44.3467 54.3532 43.8067 54.3532 43.14C54.3532 42.4333 54.2732 41.88 54.1132 41.48C53.9132 40.9467 53.5732 40.68 53.0932 40.68Z"
            style={{ fill: 'var(--text-1)' }}
          />
        </svg>
      </div>

      <div class="text-align-center color-D font-s-L margin-t-XXL margin-b-XS font-bold">{T.PageTitle}</div>

      <div class="padding-x-XXL text-align-center margin-b-XXL">
        {T.PageDescBefore}
        <span class="link-color">{T.PageDescLink}</span>
        {T.PageDescAfter}
      </div>

      <div>
        <For each={list}>
          {(item, index) => (
            <div class="flex padding-b-XL align-start">
              <If when={index() < 2}>
                <svg
                  style={{ position: 'relative', left: '11px', top: '24px', 'flex-shrink': 0 }}
                  width="1"
                  height="54"
                  viewBox="0 0 1 54"
                  stroke="none"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="0.5"
                    y1="0.5"
                    x2="0.499998"
                    y2="53"
                    style={{ stroke: 'var(--border-1)' }}
                    stroke-linecap="round"
                    stroke-dasharray="2 4"
                  />
                </svg>
              </If>

              <div
                class="color-D bg-c-XD flex align-center justify-center flex-shrink-0"
                style={{ 'border-radius': '50%', width: '20px', height: '20px', 'margin-top': '2px' }}
              >
                {index() + 1}
              </div>
              {/* border-l border-l-s-dashed  */}
              <div class="padding-l open-progress-step-content">
                <div class="color-D font-s margin-b-XS font-bold">{item.title()}</div>
                <div class="font-s-S open-progress-step-desc">{item.desc()}</div>
              </div>
            </div>
          )}
        </For>
      </div>

      <LastNextBtns
        hideLast={pState.financeTransferResumeMode}
        last={() => {
          lastProcess();
        }}
        next={() => {
          nextProcess();
        }}
      />
    </div>
  );
};
